import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col md={12}>
            <p>
              Leading innovative solutions to help your business thrive.
              <br />
              &copy; {new Date().getFullYear()} Abarka. All rights reserved.
              <br />
              Developed and managed by &nbsp;
              <a
                href="https://wisebirdz.com"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                Wisebirdz Technologies
              </a>
            </p>
            .
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
